'use client';

import { Video } from 'lucide-react';
import { useState } from 'react';

/** A library tile is a still image, never a video decoder or a thumbnail job. */
export function KagemaneVideoThumbnail({ poster, src }: { poster?: string; src?: string }) {
  const [failedPoster, setFailedPoster] = useState<string>();
  // Legacy rows sometimes put the MP4 (or an unsupported COS snapshot URL) in thumbnail_url.
  const usable = poster && poster !== src && failedPoster !== poster
    && !/\.(mp4|mov|webm|m4v|m3u8)(?:[?#]|$)/i.test(poster)
    && !/ci-process(?:=|%3D)snapshot/i.test(poster);
  return <span className="relative grid h-full w-full place-items-center bg-[#E9EDF0] text-[#819098]" aria-hidden>
    <Video className="size-6" />
    {usable && <img key={poster} src={poster} alt="" loading="lazy" decoding="async"
      className="absolute inset-0 h-full w-full object-cover"
      onError={() => setFailedPoster(poster)} />}
  </span>;
}
